/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Statistics for a single workshop.
 * @export
 * @interface WorkshopAttendanceStats
 */
export interface WorkshopAttendanceStats {
    /**
     * 
     * @type {string}
     * @memberof WorkshopAttendanceStats
     */
    workshop_id: string;
    /**
     * 
     * @type {string}
     * @memberof WorkshopAttendanceStats
     */
    workshop_name: string;
    /**
     * 
     * @type {Date}
     * @memberof WorkshopAttendanceStats
     */
    workshop_start_time: Date;
    /**
     * 
     * @type {Date}
     * @memberof WorkshopAttendanceStats
     */
    workshop_end_time: Date;
    /**
     * 
     * @type {string}
     * @memberof WorkshopAttendanceStats
     */
    mentor_name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof WorkshopAttendanceStats
     */
    class_name?: string | null;
    /**
     * 
     * @type {number}
     * @memberof WorkshopAttendanceStats
     */
    total_registered?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkshopAttendanceStats
     */
    total_checked_in?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkshopAttendanceStats
     */
    total_absent?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkshopAttendanceStats
     */
    total_excused?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkshopAttendanceStats
     */
    total_problems?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkshopAttendanceStats
     */
    total_submissions?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkshopAttendanceStats
     */
    unique_students_attempted?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkshopAttendanceStats
     */
    unique_students_solved?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkshopAttendanceStats
     */
    problems_attempted?: number;
    /**
     * 
     * @type {number}
     * @memberof WorkshopAttendanceStats
     */
    problems_solved?: number;
}

/**
 * Check if a given object implements the WorkshopAttendanceStats interface.
 */
export function instanceOfWorkshopAttendanceStats(value: object): value is WorkshopAttendanceStats {
    if (!('workshop_id' in value) || value['workshop_id'] === undefined) return false;
    if (!('workshop_name' in value) || value['workshop_name'] === undefined) return false;
    if (!('workshop_start_time' in value) || value['workshop_start_time'] === undefined) return false;
    if (!('workshop_end_time' in value) || value['workshop_end_time'] === undefined) return false;
    return true;
}

export function WorkshopAttendanceStatsFromJSON(json: any): WorkshopAttendanceStats {
    return WorkshopAttendanceStatsFromJSONTyped(json, false);
}

export function WorkshopAttendanceStatsFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkshopAttendanceStats {
    if (json == null) {
        return json;
    }
    return {
        
        'workshop_id': json['workshop_id'],
        'workshop_name': json['workshop_name'],
        'workshop_start_time': (new Date(json['workshop_start_time'])),
        'workshop_end_time': (new Date(json['workshop_end_time'])),
        'mentor_name': json['mentor_name'] == null ? undefined : json['mentor_name'],
        'class_name': json['class_name'] == null ? undefined : json['class_name'],
        'total_registered': json['total_registered'] == null ? undefined : json['total_registered'],
        'total_checked_in': json['total_checked_in'] == null ? undefined : json['total_checked_in'],
        'total_absent': json['total_absent'] == null ? undefined : json['total_absent'],
        'total_excused': json['total_excused'] == null ? undefined : json['total_excused'],
        'total_problems': json['total_problems'] == null ? undefined : json['total_problems'],
        'total_submissions': json['total_submissions'] == null ? undefined : json['total_submissions'],
        'unique_students_attempted': json['unique_students_attempted'] == null ? undefined : json['unique_students_attempted'],
        'unique_students_solved': json['unique_students_solved'] == null ? undefined : json['unique_students_solved'],
        'problems_attempted': json['problems_attempted'] == null ? undefined : json['problems_attempted'],
        'problems_solved': json['problems_solved'] == null ? undefined : json['problems_solved'],
    };
}

export function WorkshopAttendanceStatsToJSON(json: any): WorkshopAttendanceStats {
    return WorkshopAttendanceStatsToJSONTyped(json, false);
}

export function WorkshopAttendanceStatsToJSONTyped(value?: WorkshopAttendanceStats | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'workshop_id': value['workshop_id'],
        'workshop_name': value['workshop_name'],
        'workshop_start_time': ((value['workshop_start_time']).toISOString()),
        'workshop_end_time': ((value['workshop_end_time']).toISOString()),
        'mentor_name': value['mentor_name'],
        'class_name': value['class_name'],
        'total_registered': value['total_registered'],
        'total_checked_in': value['total_checked_in'],
        'total_absent': value['total_absent'],
        'total_excused': value['total_excused'],
        'total_problems': value['total_problems'],
        'total_submissions': value['total_submissions'],
        'unique_students_attempted': value['unique_students_attempted'],
        'unique_students_solved': value['unique_students_solved'],
        'problems_attempted': value['problems_attempted'],
        'problems_solved': value['problems_solved'],
    };
}

